module.exports = __webpack_public_path__ + "img/uploaddemo-4-b.0ca7e59e.png";